import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { PassportView } from "@/components/PassportView";
import { Sparkles, Loader2 } from "lucide-react";

export default function PublicProfile() {
  const { slug } = useParams();
  const [p, setP] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    api.get(`/public/profile/${slug}`).then((r) => setP(r.data)).catch(() => setErr(true));
  }, [slug]);

  if (err) return <div className="min-h-screen flex items-center justify-center text-slate-500">Profil sa nenašiel.</div>;
  if (!p) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="animate-spin text-blue-700" /></div>;

  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <header className="sticky top-0 z-40 backdrop-blur-xl bg-white/80 border-b border-slate-200">
        <div className="mx-auto max-w-md px-6 py-3 flex items-center gap-2">
          <div className="h-8 w-8 rounded-lg bg-blue-700 flex items-center justify-center"><Sparkles className="text-white" size={16} /></div>
          <span className="font-head font-bold tracking-tight">Profeeluj<span className="text-blue-700"> AI</span></span>
        </div>
      </header>
      <div className="mx-auto max-w-md px-6 py-6">
        <PassportView p={p} />
      </div>
    </div>
  );
}
